export const ADMIN_SUCCESS = 'ADMIN_SUCCESS'
export const ADMIN_FAILURE = 'ADMIN_FAILURE'

export const adminUser = (admin) =>{
    return (dispatch, getState) => {
        dispatch({ type: ADMIN_SUCCESS,admin });
    }
}